import React from 'react';
import { displayName } from '../../../App';
import MainGuidanceLayout from '../../components/Layout/Main';
import Content from '../../components/Pages/Notices';

function Notices() {
  document.title = `${displayName}: eNotices`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default Notices;
